import routeCodes from 'common/constants/route-codes';

import * as types from './types';
import { dishesSteps } from 'common/constants/menu';

const initialState = {
  listData: {
    id: 'dish-categories',
    title: 'Le tue categorie',
    description: 'Crea e modifica le categorie del tuo menù.',
    href: routeCodes.menuCategoriesEdit,
    createLink: routeCodes.menuCategoriesCreate,
    items: [],
  },
  itemLoading: true,
  currentItem: {},
  deleteInProcess: false,
  errors: null,
  listFetched: false,
  createOrUpdateInProcess: false,
  formStep: dishesSteps.first,
  completedSteps: [dishesSteps.first],
};

const dishCategoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    // case types.DISH_CATEGORY_GET_REQUEST:
    //   return {
    //     ...state,
    //     listFetched: true,
    //     listData: {
    //       ...state.listData,
    //       items: action.payload,
    //     },
    //   };
    case types.DISH_CATEGORY_GET_SUCCESS:
      return {
        ...state,
        listFetched: true,
        listData: {
          ...state.listData,
          items: action.payload,
        },
      };
    case types.RESET_DISH_CATEGORY_LIST_DATA:
      return {
        ...state,
        listFetched: false,
        listData: {
          id: 'dish-categories',
          title: 'Le tue categorie',
          description: 'Crea e modifica le categorie del tuo menù.',
          href: routeCodes.menuCategoriesEdit,
          createLink: routeCodes.menuCategoriesCreate,
          items: [],
        },
      };
    case types.DISH_CATEGORY_CREATE_OR_UPDATE_REQUEST:
      return {
        ...state,
        createOrUpdateInProcess: true,
      };
    case types.CHANGE_DISH_CATEGORY_FORM_STEP:
      return {
        ...state,
        formStep: action.payload.step,
        completedSteps: action.payload.completedSteps,
      };
    case types.RESET_DISH_CATEGORY_ERRORS:
      return {
        ...state,
        errors: null,
      };
    case types.DISH_CATEGORY_GET_BY_ID_REQUEST:
    case types.DISH_CATEGORY_GET_BY_ID_FAILURE:
      return {
        ...state,
        itemLoading: true,
      };
    case types.DISH_CATEGORY_GET_BY_ID_SUCCESS:
      return {
        ...state,
        itemLoading: true,
        currentItem: action.payload,
      };
    case types.DISH_CATEGORY_CREATE_OR_UPDATE_FAILURE:
      return {
        ...state,
        errors: action.payload,
        createOrUpdateInProcess: false,
      };
    case types.DISH_CATEGORY_CREATE_OR_UPDATE_SUCCESS:
      return {
        ...state,
        createOrUpdateInProcess: false,
      };
    case types.DISH_CATEGORY_DELETE_REQUEST:
      return {
        ...state,
        deleteInProcess: true,
      };
    case types.DISH_CATEGORY_DELETE_SUCCESS:
    case types.DISH_CATEGORY_DELETE_FAILURE:
      return {
        ...state,
        deleteInProcess: false,
      };
    case types.DISH_CATEGORY_CHANGE_POSITION_SUCCESS: {
      const { items } = state.listData;
      const { position, originalPosition } = action.payload;

      const newItems = Array.from(items);
      const [removed] = newItems.splice(originalPosition, 1);
      newItems.splice(position, 0, removed);

      return {
        ...state,
        listData: {
          ...state.listData,
          items: newItems,
        }
      };
    }
    default:
      return state;
  }
};

export default dishCategoriesReducer;
